'use client';
import * as S from './styles.ts';
import Link from 'next/link';
import { BentoBox, Button, H1 } from '@template/components';

interface IBentoSectionComponentProps {
  heading?: string;
  subHeading?: string;
  boxes?: any;
}

const BentoSectionComponent = ({
  heading,
  subHeading,
  boxes,
}: IBentoSectionComponentProps) => {
  return (
    <S.BentoSectionWrapper>
      <S.BentoSectionContainer>
        <H1 as='h2'>{heading}</H1>
        <S.BentoSectionSubHeading>{subHeading}</S.BentoSectionSubHeading>
        <S.BentoSectionItemsContainer>
          <S.BentoSectionFirstColumn>
            <BentoBox info={boxes[0]} height='460px' />

            <S.BentoSectionFirstRow>
              <BentoBox info={boxes[1]} height='220px' />
              <S.BentoBoxCta>
                <S.BentoBoxCtaText>Discover all features</S.BentoBoxCtaText>
                <Link
                  href='/voice/business-phone-system/'
                  title='Link to business phone system features'
                >
                  <Button size='lg'>VoIP Features</Button>
                </Link>
              </S.BentoBoxCta>
            </S.BentoSectionFirstRow>
          </S.BentoSectionFirstColumn>
          <S.BentoSectionSecondColumn>
            <BentoBox info={boxes[2]} height='220px' />
            <BentoBox info={boxes[3]} height='460px' />
          </S.BentoSectionSecondColumn>
        </S.BentoSectionItemsContainer>
      </S.BentoSectionContainer>
    </S.BentoSectionWrapper>
  );
};

export default BentoSectionComponent;
export const options = [
  {
    description: '',
    displayName: 'BentoSectionComponent',
    methods: [],
    props: {
      heading: {
        required: false,
        flowType: { name: 'string' },
        description: '',
      },
      subHeading: {
        required: false,
        flowType: { name: 'string' },
        description: '',
      },
      boxes: {
        required: false,
        flowType: {
          name: 'Array',
          elements: [
            {
              name: 'signature',
              type: 'object',
              raw: '{\n  heading: string;\n  subHeading: string;\n  link?: {\n    text: string;\n    href: string;\n  };\n  image: IImageProps;\n  cta?: {\n    text: string;\n    href: string;\n  };\n  flip?: boolean;\n}',
              signature: {
                properties: [
                  {
                    key: 'heading',
                    value: {
                      name: 'string',
                      required: true,
                    },
                  },
                  {
                    key: 'subHeading',
                    value: {
                      name: 'string',
                      required: true,
                    },
                  },
                  {
                    key: 'link',
                    value: {
                      name: 'signature',
                      type: 'object',
                      raw: '{\n  text: string;\n  href: string;\n}',
                      signature: {
                        properties: [
                          {
                            key: 'text',
                            value: {
                              name: 'string',
                              required: true,
                            },
                          },
                          {
                            key: 'href',
                            value: {
                              name: 'string',
                              required: true,
                            },
                          },
                        ],
                      },
                      required: false,
                    },
                  },
                  {
                    key: 'image',
                    value: {
                      name: 'IImageProps',
                      required: true,
                    },
                  },
                  {
                    key: 'cta',
                    value: {
                      name: 'signature',
                      type: 'object',
                      raw: '{\n  text: string;\n  href: string;\n}',
                      signature: {
                        properties: [
                          {
                            key: 'text',
                            value: {
                              name: 'string',
                              required: true,
                            },
                          },
                          {
                            key: 'href',
                            value: {
                              name: 'string',
                              required: true,
                            },
                          },
                        ],
                      },
                      required: false,
                    },
                  },
                  {
                    key: 'flip',
                    value: {
                      name: 'boolean',
                      required: false,
                    },
                  },
                ],
              },
            },
          ],
          raw: '{\n  heading: string;\n  subHeading: string;\n  link?: {\n    text: string;\n    href: string;\n  };\n  image: IImageProps;\n  cta?: {\n    text: string;\n    href: string;\n  };\n  flip?: boolean;\n}[]',
        },
        description: '',
      },
    },
  },
];
